import React, { useEffect } from 'react'
import ChronoPage from '@/layouts/core/components/ChronoPage'
import ProductPanel from '@/modules/product/components/ProductPanel'
import {
  StorefrontEventWithProducts} from '@/modules/event/getEvent'
import { CartIcon } from '@/modules/cart/components/CartIcon'
import { createLogger } from '@/common/logger'
import { useDispatch } from 'react-redux'
import { clearTransaction } from '@/modules/cart/cartSlice'
import { makeStyles } from "@mui/styles"
import TagContainer from '@/modules/shared/components/TagContainer'

type EventPageProps = {
  event: StorefrontEventWithProducts,
  prefix: string
}

const useStyles = makeStyles(() => ({
  eventLink: {
    fontSize: 20,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    },
    '&:visited': {
      color: 'rgb(0, 0, 255)',
    }
  },
}))

const storeStatusLabels: { [key: string]: string } = {
  EntryPage: 'No products available in the add-on store.',
  EventPage: 'Store is currently closed.',
}

const StorePage = (props: EventPageProps) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { event, prefix } = props

  const logger = createLogger({ prefix })

  useEffect(() => {
    logger.debug('Clearing transaction state...')
    // ensure that any lingering last transaction info is cleared on load
    dispatch(clearTransaction())
  })

  const renderClosedStore = () => (
    <ChronoPage
      event={event}
      label={storeStatusLabels[prefix]}
      controls={<CartIcon />}
    >
      <a href={event?.url} className={classes.eventLink}>Return to Event Website</a>
    </ChronoPage>
  )

  const renderOpenStore = () => (
    <ChronoPage
      event={event}
      label={'Store'}
      controls={<CartIcon />}
    >
      {event?.products
        ?.filter(product => product.options.length)
        .map(product => (
          <ProductPanel key={product.id} product={product} />
        ))}
        <TagContainer />
    </ChronoPage>
  )

  return event?.products?.length ? renderOpenStore() : renderClosedStore()
}

export default StorePage